module.exports = __webpack_public_path__ + "/bundle/asset/exam-2-312fce76ab12a29a0be0c60b392150ad.png";